
<app-header></app-header>
<div class="wrapper ant-layout">
	<div class="d-flex flex-row bg-secondary">
    	<div class="container full-width">
    		<div class="logo-container">
    			<div class="logo-wrapper">
					<img alt="tenderpilot-logo" src="../../../assets/logo/tp-logo-voll-quer.svg" width="390">
    			</div>
    		</div>
    		<div class="form">
    			<nz-tabset (nzSelectChange)="tabChange($event)" [nzAnimated]="false" nzLinkRouter>
    				<nz-tab>
    					<a *nzTabLink [queryParams]="{tab: 'login'}" [routerLink]="['.']" nz-tab-link
    					   queryParamsHandling="merge">{{"global.login.label.login" | translate}}</a>
    					<app-login></app-login>
    				</nz-tab>
    				<nz-tab>
    					<a *nzTabLink [queryParams]="{tab: 'signup'}" [routerLink]="['.']" nz-tab-link
    					   queryParamsHandling="merge">{{"global.login.label.sign_up" | translate}}</a>
    					<app-signup></app-signup>
    				</nz-tab>
    			</nz-tabset>
    		</div>
    	</div>
    </div>
    <div class="question-mark-wrapper">
    	<div class="question-mark">
    		<svg [nzPopoverContent]="popOverContent"
    			 fill="none"
    			 height="56"
    			 nz-popover nzPopoverPlacement="topRight" nzPopoverTitle="{{ this.popoverTitle }}" viewBox="0 0 56 56"
    			 width="56"
    			 xmlns="http://www.w3.org/2000/svg">
    			<g filter="url(#filter0_d)">
    				<path
    					d="M8 26C8 14.9543 16.9543 6 28 6C39.0457 6 48 14.9543 48 26C48 37.0457 39.0457 46 28 46C16.9543 46 8 37.0457 8 26Z"
    					fill="white"/>
    				<path
    					d="M33.0623 21.358C32.781 20.7432 32.3812 20.1908 31.871 19.7187C30.8344 18.7564 29.4582 18.226 27.9998 18.226C26.5413 18.226 25.1652 18.7564 24.1286 19.7167C23.6183 20.1908 23.2185 20.7412 22.9373 21.358C22.644 22.0008 22.4953 22.6818 22.4953 23.385V23.9274C22.4953 24.0519 22.5957 24.1524 22.7203 24.1524H23.8051C23.9297 24.1524 24.0301 24.0519 24.0301 23.9274V23.385C24.0301 21.3861 25.81 19.7609 27.9998 19.7609C30.1895 19.7609 31.9694 21.3861 31.9694 23.385C31.9694 24.2046 31.6781 24.976 31.1257 25.6189C30.5792 26.2557 29.8078 26.7118 28.954 26.9046C28.4658 27.0151 28.0259 27.2903 27.7145 27.6841C27.4042 28.0765 27.2351 28.5619 27.2344 29.0622V29.693C27.2344 29.8176 27.3348 29.918 27.4594 29.918H28.5442C28.6687 29.918 28.7692 29.8176 28.7692 29.693V29.0622C28.7692 28.7468 28.9882 28.4696 29.2915 28.4013C30.4647 28.1361 31.5295 27.5033 32.2908 26.6193C32.6745 26.1714 32.9739 25.6731 33.1808 25.1327C33.3957 24.5722 33.5042 23.9836 33.5042 23.385C33.5042 22.6818 33.3556 21.9988 33.0623 21.358ZM27.9998 31.5252C27.379 31.5252 26.8748 32.0294 26.8748 32.6502C26.8748 33.2709 27.379 33.7752 27.9998 33.7752C28.6205 33.7752 29.1248 33.2709 29.1248 32.6502C29.1248 32.0294 28.6205 31.5252 27.9998 31.5252Z"
    					fill="black" fill-opacity="0.85"/>
    			</g>
    			<defs>
    				<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="56" id="filter0_d"
    						width="56" x="0"
    						y="0">
    					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
    					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    					<feOffset dy="2"/>
    					<feGaussianBlur stdDeviation="4"/>
    					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
    					<feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow"/>
    					<feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape"/>
    				</filter>
    			</defs>
    		</svg>
    	</div>
    </div>

    <ng-template #popOverContent>
    	<div *ngIf="tab === 'signup'; else elseBlock">
    		<h4>{{ 'global.login.register_help.step' | translate }} 1:</h4>
    		<p>{{ 'global.login.register_help.descriptions.first' | translate }}</p>

    		<h4>{{ 'global.login.register_help.step' | translate }} 2:</h4>
    		<p>{{ 'global.login.register_help.descriptions.second' | translate }}</p>

    		<h4>{{ 'global.login.register_help.step' | translate }} 3:</h4>
    		<p>
    			{{ 'global.login.register_help.descriptions.third' | translate }} <br>
    			{{ 'global.login.register_help.descriptions.third_2' | translate }}
    		</p>

    		<h4>{{ 'global.login.register_help.step' | translate }} 4:</h4>
    		<p>
    			{{ 'global.login.register_help.descriptions.fourth' | translate }} <br>
    			{{ 'global.login.register_help.descriptions.password_1' | translate }} <br>
    			{{ 'global.login.register_help.descriptions.password_2' | translate }} <br>
    			{{ 'global.login.register_help.descriptions.password_3' | translate }}
    		</p>
    		<h4>{{ 'global.login.register_help.step' | translate }} 5:</h4>
    		<p>{{ 'global.login.register_help.descriptions.fifth' | translate }}</p>
    	</div>
    	<ng-template #elseBlock>
    		<h4>{{ 'global.login.login_help.step' | translate }} 1.</h4>
    		<p>{{ 'global.login.login_help.descriptions.first' | translate }}</p>
    		<h4>{{ 'global.login.login_help.step' | translate }} 2.</h4>
    		<p>
    			{{ 'global.login.login_help.descriptions.second' | translate }} <br>
    			{{ 'global.login.login_help.descriptions.second_2' | translate }} <br>
    			{{ 'global.login.login_help.descriptions.second_3' | translate }}
    		</p>
    	</ng-template>
    </ng-template>
</div>

<app-footer></app-footer>
